import { FormattedMessage } from 'react-intl';

const UserRolesPermissions = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="JiraSoftwarePricingPageTeam24.features.userRolesPermissions.content.body"
					defaultMessage="Control what users can create, view, and comment on in Jira."
				/>
			</p>
		</div>
	);
};

export default UserRolesPermissions;
